import { tabKeys, } from '../../../modules/Constants';

const ServicesList = {
  beaufort_v1: {
    id: tabKeys.BEAUFORT_KEY,
    location: 'Beaufort County, South Carolina',
    description: 'Pay real, personal, and vehicle property taxes.',
    tooltipDescription: 'beaufort_v1',
  },
  douglas_property_tax: {
    id: 'douglas_property_tax',
    location: 'Douglas County, Nebraska',
    description: 'Search, link, and pay property taxes.',
    tooltipDescription: 'douglas_property_tax',
  },
  fldmv: {
    id: tabKeys.FLORIDA_DMV_KEY,
    location: 'State of Florida',
    description: 'Renew vehicles.',
    tooltipDescription: 'fldmv',
  },
  gr_block_grants: {
    id: 'gr_block_grants',
    location: 'City of Grand Rapids, Michigan',
    description: 'Pay community development loans.',
    tooltipDescription: 'gr_block_grants',
  },
  gr_income_tax: {
    id: 'gr_income_tax',
    location: 'City of Grand Rapids, Michigan',
    description: 'Pay income taxes.',
    tooltipDescription: 'gr_income_tax',
  },
  gr_parking: {
    id: 'gr_parking',
    location: 'City of Grand Rapids, Michigan',
    description: 'Pay parking citations.',
    tooltipDescription: 'gr_parking',
  },
  gr_property_tax: {
    id: 'gr_property_tax',
    location: 'City of Grand Rapids, Michigan',
    description: 'Pay property taxes.',
    tooltipDescription: 'gr_property_tax',
  },
  gr_refuse: {
    id: tabKeys.GR_REFUSE_KEY,
    location: 'City of Grand Rapids, Michigan',
    description: 'Pay refuse bills.',
    tooltipDescription: 'gr_refuse',
  },
  gr_water: {
    id: tabKeys.GR_WATER_KEY,
    location: 'City of Grand Rapids, Michigan',
    description: 'Pay water bills',
    tooltipDescription: 'View water accounts and bills and remove autopay.',
  },
  gr_water_v2: {
    id: 'gr_water_v2',
    location: 'City of Grand Rapids, Michigan',
    description: 'Pay water bills',
    tooltipDescription: 'View water accounts and bills and remove autopay. 2.0',
  },
  jackson_property_tax: {
    id: 'jackson_property_tax',
    location: 'Jackson County, Missouri',
    description: 'Pay property taxes.',
    tooltipDescription: 'jackson_property_tax',
  },
  kck_311: {
    id: 'kck_311',
    location: 'Wyandotte County, Kansas / City of Kansas City, Kansas',
    description: 'Report or make requests for non-emergency muncipal services.',
    tooltipDescription: 'kck_311',
  },
  kck_tax: {
    id: 'kck_tax',
    location: 'Wyandotte County, Kansas / City of Kansas City, Kansas',
    description: 'Pay personal and real estate property taxes.',
    tooltipDescription: 'kck_tax',
  },
  kck_tax_personal: {
    id: 'kck_tax_personal',
    location: 'Wyandotte County, Kansas / City of Kansas City, Kansas',
    description: 'Pay personal property taxes.',
    tooltipDescription: 'kck_tax_personal',
  },
  ks_dmv: {
    id: 'ks_dmv',
    location: 'State of Kansas',
    description: 'Renew vehicles.',
    tooltipDescription: 'ks_dmv',
  },
  ks_drivers_license: {
    id: 'ks_drivers_license',
    location: 'State of Kansas',
    description: "Renew driver's licenses.",
    tooltipDescription: 'ks_drivers_license',
  },
  ks_dl_address_change: {
    id: 'ks_dl_address_change',
    location: 'State of Kansas',
    description: "KS Driver's License Address Change.",
    tooltipDescription: 'ks_dl_address_change',
  },
  ks_vitals: {
    id: 'ks_vitals',
    location: 'State of Kansas',
    description:
            'Make vital records requests for birth, death, marriage, and divorce, and order certificates by mail.',
    tooltipDescription: 'ks_vitals',
  },
  nc_drivers_license: {
    id: tabKeys.NCDL_KEY,
    location: 'State of North Carolina',
    description: "Renew driver's licenses.",
    tooltipDescription: 'nc_drivers_license',
  },
  ncdmv_driving_record: {
    id: tabKeys.NCDMV_DRIVING_RECORD_KEY,
    location: 'State of North Carolina',
    description: 'NCDMV Driving Records',
    tooltipDescription: 'ncdmv_driving_record',
  },
  ncdmv_hearing_fee: {
    id: tabKeys.NCDMV_HEARING_FEE_KEY,
    location: 'State of North Carolina',
    description: 'NCDMV Hearing Fees',
    tooltipDescription: 'ncdmv_hearing_fee',
  },
  nc_handicap_placard: {
    id: tabKeys.NC_HANDICAP_PLACARD,
    location: 'State of North Carolina',
    description: 'NCDMV Handicap Placard',
    tooltipDescription: 'nc_handicap_placard',
  },
  nc_identity_verification: {
    id: tabKeys.NC_IDENTITY_VERIFICATION,
    location: 'State of North Carolina',
    description: 'NC Identity Verification',
    tooltipDescription: 'nc_identity_verification',
  },
  ncdmv_driveway_permits: {
    id: tabKeys.NCDMV_DRIVEWAY_PERMITS,
    location: 'State of North Carolina',
    description: 'NCDMV Driveway Permits',
    tooltipDescription: 'ncdmv_driveway_permits',
  },
  ncdmv_hearing_fee_license_and_theft: {
    id: tabKeys.NC_HF_AHS,
    location: 'State of North Carolina',
    description: 'NCDMV License and Theft Hearings',
    tooltipDescription: 'ncdmv_hearing_fee_license_and_theft',
  },
  ncdmv_civil_penalty_license_and_theft: {
    id: tabKeys.NC_CP_AHS,
    location: 'State of North Carolina',
    description: 'NCDMV License and Theft Civil Penalty',
    tooltipDescription: 'ncdmv_civil_penalty_license_and_theft',
  },
  ncdmv_crash_reports: {
    id: tabKeys.NCDMV_CRASH_REPORTS,
    location: 'State of North Carolina',
    description: 'NCDMV Crash Reports',
    tooltipDescription: 'ncdmv_crash_reports',
  },
  ncdmv: {
    id: tabKeys.NCDMV_KEY,
    location: 'State of North Carolina',
    description: 'Renew vehicles.',
    tooltipDescription: 'License plate and registration lookup.',
  },
  shelby_tax_v1: {
    id: tabKeys.SHELBY_KEY,
    location: 'Shelby County, Tennessee',
    description: 'Pay property taxes.',
    tooltipDescription: 'shelby_tax_v1',
  },
  stl_property: {
    id: 'stl_property',
    location: 'City of St. Louis, Missouri',
    description: 'Pay property taxes.',
    tooltipDescription: 'stl_property',
  },
  stl_real_estate: {
    id: 'stl_real_estate',
    location: 'City of St. Louis, Missouri',
    description: 'Pay real estate taxes.',
    tooltipDescription: 'stl_real_estate',
  },
  stl_water: {
    id: 'stl_water',
    location: 'City of St. Louis, Missouri',
    description: 'Pay water and refuse bills.',
    tooltipDescription: 'stl_water',
  },
  ivr: {
    id: tabKeys.IVR_KEY,
    location: 'IVR Conversations',
    description: 'Lookup IVR conversations',
    tooltipDescription: 'ivr conversation lookup',
  },
  ok_vehicle_registration: {
    id: 'ok_vehicle_registration',
    location: 'State of Oklahoma',
    description: 'Vehicle Registration.',
    tooltipDescription: 'ok_vehicle_registration',
  },
  ncdmv_insurance_lapse: {
    id: tabKeys.NC_INSURANCE_LAPSE_KEY,
    location: 'State of North Carolina',
    description: 'NCDMV Insurance Lapse',
    tooltipDescription: 'ncdmv_insurance_lapse',
  },
  ncdmv_hearing_fee_lite: {
    id: tabKeys.NC_HF_LITES_KEY,
    location: 'State of North Carolina',
    description: 'NCDMV Hearing Fees LITES',
    tooltipDescription: 'ncdmv_hearing_fee_lite',
  },
};

export default ServicesList;
